module.exports = __webpack_public_path__ + "static/help_center-23fbaa5f0d89c1c3157a1605f34b413e.webp";